import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { DiscountBanner as BannerWithDiscount } from '@dev/ee-components';
// import { ProductCode } from '@dev/ee-api/ee-api-models';

import { useMobile } from '../../hooks/useMobile';
import { useDiscount } from '../../hooks/useDiscount';
import { usePaymentError } from '@api/services/hooks/usePaymentError';
import { ShowDialog } from '@api/store/dialog/actions';
import { useTranslation } from 'react-i18next';
import { BillingPaths, LegacyPaths, pathsParams } from '@api/services/dictionaries/paths';
import { ProductCode } from '@dev/ee-api/ee-api-models';
// import { LoginWithDisposableToken } from '@api/store/account/actions';

export interface DiscountBannerOverlayInterface {
    disableButton?: boolean;
}

export const DiscountBanner: FC<DiscountBannerOverlayInterface> = ({ disableButton }: DiscountBannerOverlayInterface): JSX.Element => {
    const [isButtonHidden, setIsButtonHidden] = useState(false);
    const isMobile = useMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { anyPaymentError } = usePaymentError();
    const { discountEnabled, discount, discountDuration, discountExpireDay } = useDiscount();

    useEffect(() => {
        setIsButtonHidden(disableButton);
    }, []);

    if (!discountEnabled) {
        return <></>;
    }

    const handleBuyButtonClick = () => {
        if (anyPaymentError) {
            //TODO: renew!
            dispatch(
                ShowDialog({
                    title: t('upgradenotavailable'),
                    body: t('upgradenotavailable_desc_discover_products'),
                    confirmLabel: t('renew'),
                    onClickConfirm: () => {
                        window.location.href = `${location.origin}${LegacyPaths.Billing}`;
                    },
                    cancelLabel: t('cancel'),
                })
            );
            return;
        }
        // dispatch(LoginWithDisposableToken({ productCode: ProductCode.EmailApi, isBilling: true }));

        window.location.href = `${location.origin}${BillingPaths.BillingPlanList.replace(
            pathsParams.productCode,
            ProductCode.EmailApi.toLowerCase()
        )}`;
    };

    return (
        <BannerWithDiscount
            expireDay={discountExpireDay}
            discount={discount}
            discountDuration={discountDuration}
            isMobile={isMobile}
            buttonOnClick={!isButtonHidden && handleBuyButtonClick}
        />
    );
};
